import { BellOutlined } from '@ant-design/icons';
import { useAlerts } from '@contexts/alerts-context';
import { Link } from 'react-router';

const AlertsCounter = () => {
  const { totalActiveCount } = useAlerts();

  return (
    <div style={{ position: 'relative' }}>
      <Link style={{ color: 'inherit' }} to="/alerts">
        <BellOutlined style={{ fontSize: '1.5em', cursor: 'pointer' }} />
      </Link>
      <div
        style={{
          position: 'absolute',
          top: '25%',
          right: '-10%',
          borderRadius: '50%',
          width: '65%',
          height: 'auto',
          paddingTop: '65%',
          background: '#d42628',
          zIndex: 10,
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: 'white',
            fontSize: '0.8em',
          }}
        >
          {totalActiveCount || 0}
        </span>
      </div>
    </div>
  );
};

export { AlertsCounter };
